import noop from 'lodash/noop';
import { createContext } from 'react';

import { AddBundleOptions, CartModel, PromoModel, UpsellModel } from './models';

export const initialCartModel: CartModel = {
  isLoading: false,
  cart: {
    bundle: null,
    softwarePlan: null,
    products: [],
    upsell: [],
  },
  checkout: {
    count: 0,
    subtotal: 0,
    tax: null,
    promo: {
      program: null,
      applied: null,
    },
    installmentPlans: [],
    softwareTotal: 0,
  },
};

export interface CartContextProps extends CartModel {
  addBundleById: (bundleId: string, options?: AddBundleOptions) => void;
  addProduct: (product: UpsellModel) => void;
  addPromo: (promo: PromoModel) => void;
  emptyCart: () => void;
  removeProductById: (productId: string) => void;
  removePromo: () => void;
  setTaxRate: (tax: number) => void;
  updateProductQuantityById: (productId: string, quantity: number) => void;
}

export const initialCartContext: CartContextProps = {
  ...initialCartModel,
  addBundleById: noop,
  addProduct: noop,
  addPromo: noop,
  emptyCart: noop,
  removeProductById: noop,
  removePromo: noop,
  setTaxRate: noop,
  updateProductQuantityById: noop,
};

export const CartContext = createContext<CartContextProps>(initialCartContext);
